module.exports = __webpack_public_path__ + "a6fe8a10b8af6193bc7cdf31a966167a.svg";